import React from 'react';
import { translate } from "react-admin";
import { AdminSideMenu, OperatorSideMenu, SupportSideMenu,PromoterSideMenu,StoreSideMenu, AmbassadorSideMenu, PromoterStaffSideMenu } from './menu-permissions'


const MenuWithPermission = ({ handleToggle, menuCatalog, menuBusiness, menuDocs, open, onMenuClick, translate }) => {
    return (
        <>
            <AdminSideMenu
                handleToggle={handleToggle}
                menuBusiness={menuBusiness}
                menuDocs={menuDocs}
                menuCatalog={menuCatalog}
                open={open}
                translate={translate}
                onMenuClick={onMenuClick}
            ></AdminSideMenu>
            <OperatorSideMenu
                handleToggle={handleToggle}
                menuBusiness={menuBusiness}
                menuDocs={menuDocs}
                menuCatalog={menuCatalog}
                open={open}
                translate={translate}
                onMenuClick={onMenuClick}
            ></OperatorSideMenu>
            <SupportSideMenu
                handleToggle={handleToggle}
                menuBusiness={menuBusiness}
                menuDocs={menuDocs}
                menuCatalog={menuCatalog}
                open={open}
                translate={translate}
                onMenuClick={onMenuClick}
            ></SupportSideMenu>
            <PromoterSideMenu
                handleToggle={handleToggle}
                menuBusiness={menuBusiness}
                menuDocs={menuDocs}
                menuCatalog={menuCatalog}
                open={open}
                translate={translate}
                onMenuClick={onMenuClick}
            ></PromoterSideMenu>
            <PromoterStaffSideMenu
                handleToggle={handleToggle}
                menuBusiness={menuBusiness}
                menuDocs={menuDocs}
                menuCatalog={menuCatalog}
                open={open}
                translate={translate}
                onMenuClick={onMenuClick}
            ></PromoterStaffSideMenu>
            <StoreSideMenu
                handleToggle={handleToggle}
                menuBusiness={menuBusiness}
                menuDocs={menuDocs}
                menuCatalog={menuCatalog}
                open={open}
                translate={translate}
                onMenuClick={onMenuClick}
            ></StoreSideMenu>
            <AmbassadorSideMenu
                handleToggle={handleToggle}
                menuBusiness={menuBusiness}
                menuDocs={menuDocs}
                menuCatalog={menuCatalog}
                open={open}
                translate={translate}
                onMenuClick={onMenuClick}
            ></AmbassadorSideMenu>
        </>
    )
}


export default translate(MenuWithPermission);